export default "__VITE_ASSET__4e7cb041__"